import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Grid3X3, List } from 'lucide-react';
import './FurnitureCategories.css';
import mobila1 from '../assests/bucatarie alba mobilier coamdna sector 2.jpeg'
import mobila2 from '../assests/bucatarie alba riflaje .jpeg'
import mobila3 from '../assests/bucatarie bej comanda.jpeg'
import mobila4 from '../assests/Bucatarie gri mobila coamnda.jpeg'
import mobila5 from '../assests/bucatarie mobila comanda bucuresti.jpeg'
import mobila6 from '../assests/bucatarie mobila comanda sector 2 Bucuresti.jpeg'

import mobila8 from '../assests/bucatarie mobila comanda sector 3.jpeg'

import mobila10 from '../assests/bucatarie neagra mobilier coamanda.jpeg'
import mobila11 from '../assests/bucatarie neagra mobilier sector 2.jpeg'
import mobila12 from '../assests/dulap alb coamnda mobilier.jpeg'
import mobila13 from '../assests/dulap alb mobilier comanda.jpeg'

import mobilia15 from '../assests/dulap comanda sector 3.jpeg'
import mobila16 from '../assests/dulap comanda.jpeg'
import mobila17 from '../assests/dulap maro mobilier comanda.jpeg'
import mobila18 from '../assests/dulap mobilier coamnda sector 2.jpeg'
import mobila19 from '../assests/dulap modular comanda.jpeg'
import mobila20 from '../assests/dulap riflaje.jpeg'
import mobila21 from '../assests/dulap suport perete riflaj.jpeg'
import mobila22 from '../assests/dulap negru mobilier comanda.jpeg'
import mobila23 from '../assests/dulap mobilier coamnda.jpeg'
import mobila24 from '../assests/dulap mobilier comanda bucuresti.jpeg'
import mobila25 from '../assests/dulap modular mobilier comanda.jpeg'
import mobila26 from '../assests/dulap sector 2.jpeg'
import mobila27 from '../assests/dulap-masa coamnda sector 2.jpeg'
import mobila28 from '../assests/masa mobilier comanda.jpeg'
import mobila29 from '../assests/noptiera coamnda.jpeg'
import mobila30 from '../assests/pat mobilier comanda.jpeg'

import mobila32 from '../assests/perete riflaj perete.jpeg'
import mobila33 from '../assests/suport calorifer.jpeg'
import dulapMobila from '../assests/Dulap mobila comanda sector2.jpeg'
import Riflaj from '../assests/Riiflaj dulap living.jpeg'
import mobila35 from '../assests/mobila comanda 1.jpeg'

import mobila36 from '../assests/mobila comanda 3.jpeg'
import mobila37 from '../assests/mobila comanda 4.jpeg'
import mobila38 from '../assests/mobila comanda 5.jpeg'
import mobila39 from '../assests/mobila comanda 6.jpeg'
import mobila40 from '../assests/mobila comanda 7.jpeg'
import mobila41 from '../assests/mobila comanda 8.jpeg'
import mobila42 from '../assests/mobila comanda 9.jpeg'
import mobila43 from '../assests/mobila comanda 10.jpeg'
import mobila44 from '../assests/mobila comanda 11.jpeg'
import mobila45 from '../assests/mobila comanda 12.jpeg'
import mobila46 from '../assests/mobila comanda 13.jpeg'
import mobila47 from '../assests/mobila comanda 14.jpeg'
import mobila48 from '../assests/mobila comanda 15.jpeg'
import mobila49 from '../assests/mobila comanda 16.jpeg'
import mobila51 from '../assests/mobila comanda 17.jpeg'
import mobila52 from '../assests/mobila comanda 17.jpeg'
import mobila53 from '../assests/mobila comanda 18.jpeg'



const FurnitureGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('toate');
  const [lightboxImage, setLightboxImage] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [viewMode, setViewMode] = useState('masonry'); // masonry or grid

  const categoriesData = {
    bucatarii: {
      title: "Bucătării Moderne Sector 2",
      subtitle: "Design personalizat și funcționalitate maximă",
      description: "Bucătării la comandă cu materiale premium, montaj profesionist în București Sector 2.",
      color: "#2563eb",
      images: [
        { img: mobila10, title: "Bucătărie Modernă Minimalistă", category: "bucatarii" },
        { img: mobila11, title: "Bucătărie Clasică Premium", category: "bucatarii" },
        { img: mobila4, title: "Bucătărie Compactă Smart", category: "bucatarii" },
        { img: mobila3, title: "Bucătărie Elegantă Bej", category: "bucatarii" },
        { img: mobila1, title: "Bucătărie Alba Sector 2", category: "bucatarii" },
        { img: mobila2, title: "Bucătărie cu Riflaje", category: "bucatarii" },
        { img: mobila5, title: "Bucătărie Mobilier Bucuresti", category: "bucatarii" },
        { img: mobila6, title: "Bucătărie Sector 2", category: "bucatarii" },
      ]
    },
    dormitoare: {
      title: "Dormitoare facute la comanda în București sector 2",
      subtitle: "Confort și stil personalizat",
      description: "Mobilier dormitor la comandă pentru un confort maxim.",
      color: "#059669",
      images: [
        { img: mobila13, title: "Dulap Alb la Comanda", category: "dormitoare" },
        { img: mobilia15, title: "Dulap Modern", category: "dormitoare" },
        { img: mobila16, title: "Dulap Personalizat", category: "dormitoare" },
        { img: mobila17, title: "Dulap Maro", category: "dormitoare" },
        { img: mobila18, title: "Dulap Sector 2", category: "dormitoare" },
        { img: mobila19, title: "Dulap Modular", category: "dormitoare" },
        { img: mobila20, title: "Dulap cu Riflaje", category: "dormitoare" },
        { img: mobila21, title: "Suport Perete Riflaj", category: "dormitoare" },
        { img: mobila22, title: "Dulap Negru", category: "dormitoare" },
      ]
    },
    livinguri: {
      title: "Living-uri Contemporane",
      subtitle: "Spații de relaxare",
      description: "Dulapuri facute la comanda si riflaje realizate profesionist",
      color: "#dc2626",
      images: [
        { img: mobila25, title: "Dulap Modular Living", category: "livinguri" },
        { img: mobila26, title: "Dulap Sector 2", category: "livinguri" },
        { img: mobila27, title: "Dulap-Masa Comanda", category: "livinguri" },
        { img: mobila28, title: "Masa Mobilier", category: "livinguri" },
        { img: mobila29, title: "Noptiera Comanda", category: "livinguri" },
        { img: mobila30, title: "Pat Mobilier", category: "livinguri" },
        { img: mobila35, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila36, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila37, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila38, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila39, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila40, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila41, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila42, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila43, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila44, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila45, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila46, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila47, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila48, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila49, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila51, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila52, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        { img: mobila53, title: "mobila sector 2 Bucuresti-Voluntari", category: "livinguri" },
        
        
      ]
    },
    dressings: {
      title: "Dressing-uri Personalizate",
      subtitle: "Organizare perfectă",
      description: "Sisteme de organizare profesionale pentru garderoba ta.",
      color: "#7c3aed",
      images: [
        { img: mobila32, title: "Perete Riflaj", category: "dressings" },
        { img: mobila33, title: "Suport Calorifer", category: "dressings" },
        { img: mobila8, title: "Bucătărie Sector 3", category: "dressings" },
        { img: mobila23, title: "Dulap Mobilier", category: "dressings" },
        { img: mobila24, title: "Dulap Bucuresti", category: "dressings" },
        { img: mobila12, title: "Dulap Alb", category: "dressings" },
        { img: dulapMobila, title: "Dulap Sector 2", category: "dressings" },
        { img: Riflaj, title: "Riflaj Living", category: "dressings" },
      ]
    }
  };

  // Flatten all images for lightbox navigation
  const allImages = Object.values(categoriesData).flatMap(category => category.images);
  const filteredImages = selectedCategory === 'toate' 
    ? allImages 
    : allImages.filter(img => img.category === selectedCategory);

  const openLightbox = (image, index) => {
    setLightboxImage(image);
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    setLightboxIndex(0);
  };

  const nextImage = () => {
    const nextIndex = (lightboxIndex + 1) % filteredImages.length;
    setLightboxIndex(nextIndex);
    setLightboxImage(filteredImages[nextIndex]);
  };

  const prevImage = () => {
    const prevIndex = lightboxIndex === 0 ? filteredImages.length - 1 : lightboxIndex - 1;
    setLightboxIndex(prevIndex);
    setLightboxImage(filteredImages[prevIndex]);
  };

  const CategoryFilter = () => (
    <div className="filter-section">
      <div className="filter-header">
        <h1 className="gallery-title">Galerie Mobilier</h1>
        <div className="view-controls">
          <button
            onClick={() => setViewMode('masonry')}
            className={`view-btn ${viewMode === 'masonry' ? 'active' : ''}`}
          >
            <Grid3X3 size={18} />
          </button>
          <button
            onClick={() => setViewMode('grid')}
            className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
          >
            <List size={18} />
          </button>
        </div>
      </div>
      
      <div className="filter-buttons">
        <button
          onClick={() => setSelectedCategory('toate')}
          className={`filter-btn ${selectedCategory === 'toate' ? 'active' : ''}`}
        >
          Toate ({allImages.length})
        </button>
        {Object.entries(categoriesData).map(([key, data]) => (
          <button
            key={key}
            onClick={() => setSelectedCategory(key)}
            className={`filter-btn ${selectedCategory === key ? 'active' : ''}`}
            style={{ '--category-color': data.color }}
          >
            {data.title.split(' ')[0]} ({data.images.length})
          </button>
        ))}
      </div>
    </div>
  );

  const ImageGrid = () => (
    <div className={`gallery-grid ${viewMode}`}>
      {filteredImages.map((image, index) => (
        <div
          key={`${image.category}-${index}`}
          className="gallery-item"
          onClick={() => openLightbox(image, index)}
          style={{
            '--item-height': viewMode === 'masonry' ? `${Math.floor(Math.random() * 200) + 250}px` : '300px'
          }}
        >
          <img src={image.img} alt={image.title} className="gallery-image" />
          <div className="image-overlay">
            <h3 className="image-title">{image.title}</h3>
            <span 
              className="category-tag"
              style={{ backgroundColor: categoriesData[image.category]?.color }}
            >
              {categoriesData[image.category]?.title.split(' ')[0]}
            </span>
          </div>
        </div>
      ))}
    </div>
  );

  const Lightbox = () => {
    if (!lightboxImage) return null;

    return (
      <div className="lightbox-overlay" onClick={closeLightbox}>
        <div className="lightbox-content" onClick={e => e.stopPropagation()}>
          <button className="lightbox-close" onClick={closeLightbox}>
            <X size={24} />
          </button>
          
          <button className="lightbox-nav lightbox-prev" onClick={prevImage}>
            <ChevronLeft size={24} />
          </button>
          
          <button className="lightbox-nav lightbox-next" onClick={nextImage}>
            <ChevronRight size={24} />
          </button>

          <img src={lightboxImage.img} alt={lightboxImage.title} className="lightbox-image" />
          
          <div className="lightbox-info">
            <h3>{lightboxImage.title}</h3>
            <span className="lightbox-counter">
              {lightboxIndex + 1} / {filteredImages.length}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="furniture-gallery">
      <CategoryFilter />
      <ImageGrid />
      <Lightbox />

      <style jsx>{`
      
        .furniture-gallery {
          min-height: 100vh;
          background: #fafafa;
          padding: 20px;
        }

        .filter-section {
          max-width: 1400px;
          margin: 0 auto 40px;
        }

        .filter-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
        }

        .gallery-title {
          font-size: 2.5rem;
          font-weight: 300;
          color: #1a1a1a;
          margin: 0;
        }

        .view-controls {
          display: flex;
          gap: 8px;
          background: white;
          border-radius: 12px;
          padding: 4px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .view-btn {
          padding: 8px 12px;
          border: none;
          background: transparent;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s ease;
          color: #666;
        }

        .view-btn.active {
          background: #1a1a1a;
          color: white;
        }

        .filter-buttons {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          justify-content: center;
        }

        .filter-btn {
          padding: 12px 24px;
          border: 2px solid #e5e5e5;
          background: white;
          border-radius: 25px;
          cursor: pointer;
          transition: all 0.3s ease;
          font-weight: 500;
          color: #666;
          position: relative;
          overflow: hidden;
        }

        .filter-btn:hover {
          border-color: var(--category-color, #1a1a1a);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .filter-btn.active {
          background: var(--category-color, #1a1a1a);
          border-color: var(--category-color, #1a1a1a);
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        }

        .gallery-grid {
          max-width: 1400px;
          margin: 0 auto;
          gap: 20px;
        }

        .gallery-grid.masonry {
          columns: 4;
          column-gap: 20px;
        }

        .gallery-grid.grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        }

        .gallery-item {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.4s ease;
          position: relative;
          margin-bottom: 20px;
          break-inside: avoid;
          height: var(--item-height);
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
        }

        .gallery-grid.grid .gallery-item {
          height: 300px;
        }

        .gallery-item:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        }

        .gallery-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.4s ease;
        }

        .gallery-item:hover .gallery-image {
          transform: scale(1.1);
        }

        .image-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(transparent, rgba(0,0,0,0.8));
          padding: 30px 20px 20px;
          opacity: 0;
          transition: opacity 0.3s ease;
          color: white;
        }

        .gallery-item:hover .image-overlay {
          opacity: 1;
        }

        .image-title {
          font-size: 1.1rem;
          font-weight: 500;
          margin: 0 0 8px 0;
        }

        .category-tag {
          display: inline-block;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .lightbox-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          backdrop-filter: blur(10px);
        }

        .lightbox-content {
          position: relative;
          max-width: 90vw;
          max-height: 90vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .lightbox-image {
          max-width: 100%;
          max-height: 80vh;
          object-fit: contain;
          border-radius: 12px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.5);
        }

        .lightbox-close {
          position: absolute;
          top: -50px;
          right: 0;
          background: rgba(255,255,255,0.1);
          border: 2px solid rgba(255,255,255,0.2);
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          cursor: pointer;
          transition: all 0.2s ease;
          backdrop-filter: blur(10px);
        }

        .lightbox-close:hover {
          background: rgba(255,255,255,0.2);
          transform: scale(1.1);
        }

        .lightbox-nav {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255,255,255,0.1);
          border: 2px solid rgba(255,255,255,0.2);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          cursor: pointer;
          transition: all 0.2s ease;
          backdrop-filter: blur(10px);
        }

        .lightbox-nav:hover {
          background: rgba(255,255,255,0.2);
          transform: translateY(-50%) scale(1.1);
        }

        .lightbox-prev {
          left: -70px;
        }

        .lightbox-next {
          right: -70px;
        }

        .lightbox-info {
          position: absolute;
          bottom: -60px;
          left: 0;
          right: 0;
          text-align: center;
          color: white;
        }

        .lightbox-info h3 {
          margin: 0 0 8px 0;
          font-size: 1.2rem;
          font-weight: 500;
        }

        .lightbox-counter {
          font-size: 0.9rem;
          opacity: 0.8;
        }

        @media (max-width: 1200px) {
          .gallery-grid.masonry {
            columns: 3;
          }
        }

        @media (max-width: 768px) {
          .gallery-title {
            font-size: 2rem;
          }
          
          .filter-header {
            flex-direction: column;
            gap: 20px;
            align-items: stretch;
          }
          
          .filter-buttons {
            justify-content: center;
          }
          
          .filter-btn {
            padding: 10px 16px;
            font-size: 0.9rem;
          }
          
          .gallery-grid.masonry {
            columns: 2;
            gap: 15px;
          }
          
          .gallery-grid.grid {
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            gap: 15px;
          }
          
          .gallery-item {
            margin-bottom: 15px;
          }

          .lightbox-content {
            max-width: 95vw;
            max-height: 95vh;
            padding: 10px;
          }
          
          .lightbox-image {
            max-height: 75vh;
            border-radius: 10px;
          }

          .lightbox-nav {
            width: 44px;
            height: 44px;
            background: rgba(0,0,0,0.7);
            backdrop-filter: blur(10px);
          }
          
          .lightbox-prev {
            left: -60px;
          }
          
          .lightbox-next {
            right: -60px;
          }
          
          .lightbox-close {
            width: 44px;
            height: 44px;
            top: -60px;
            background: rgba(0,0,0,0.7);
            backdrop-filter: blur(10px);
          }
          
          .lightbox-info {
            bottom: -70px;
            background: rgba(0,0,0,0.7);
            padding: 12px;
            border-radius: 10px;
            backdrop-filter: blur(10px);
          }
        }

        @media (max-width: 480px) {
        /* FULLSCREEN LIGHTBOX (design 2) */
.lightbox-overlay {
  display: none;
  position: fixed;
  z-index: 10000;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0,0,0,0.95);
  text-align: center;
}


          .gallery-grid.masonry {
            columns: 1;
          }
          
          .gallery-grid.grid {
            grid-template-columns: 1fr;
          }
          
          .lightbox-overlay {
            padding: 10px;
          }
          
          .lightbox-content {
            max-width: 100vw;
            max-height: 100vh;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          
          .lightbox-image {
            max-width: 100%;
            max-height: 70vh;
            width: auto;
            height: auto;
            border-radius: 8px;
          }
          
          .lightbox-close {
            position: fixed;
            top: 20px;
            right: 20px;
            width: 44px;
            height: 44px;
            z-index: 10000;
            background: rgba(0,0,0,0.8);
            backdrop-filter: blur(10px);
          }
          
          .lightbox-nav {
            position: fixed;
            top: 50%;
            transform: translateY(-50%);
            width: 44px;
            height: 44px;
            background: rgba(0,0,0,0.8);
            backdrop-filter: blur(10px);
            z-index: 10000;
          }
          
          .lightbox-prev {
            left: 15px;
          }
          
          .lightbox-next {
            right: 15px;
          }
          
          .lightbox-info {
            position: fixed;
            bottom: 20px;
            left: 20px;
            right: 20px;
            background: rgba(0,0,0,0.8);
            padding: 15px;
            border-radius: 12px;
            backdrop-filter: blur(10px);
          }
          
          .lightbox-info h3 {
            font-size: 1rem;
            margin: 0 0 5px 0;
          }
          
          .lightbox-counter {
            font-size: 0.8rem;
          }
        }
      `}</style>
    </div>
  );
};

export default FurnitureGallery;